module.exports = __webpack_public_path__ + "static/media/map-pin-red.ce2423cd.png";